/* eslint-disable @typescript-eslint/camelcase */

const configElem = JSON.parse(
  document.getElementById("BV2Config")?.textContent || ""
);

export const config = {
  oidc: {
    authority: configElem.oidc.authority,
    client_id: configElem.oidc.client_id,
    scopes: configElem.oidc.scopes,
  },
  api: {
    url: configElem.api.url,
  },
  path: process.env.NODE_ENV === "production" ? "" : "",
};
